import { schema } from 'normalizr';

export const matcheschema = new schema.Entity('matches');
export const matchListSchema = [ matcheschema ];



// WEBPACK FOOTER //
// ./src/schemas/match.js